import React from "react";
import { IconButton, Tooltip } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import { useDispatch } from "react-redux";
import { deleteSubscription } from "../../../Reducer/Subscription/subscriptionPlanSlice";

const DeleteSubscriptionButton = ({ planId, planTitle }) => {
  const dispatch = useDispatch();

  const handleDelete = async () => {
    const confirm = window.confirm(`Are you sure you want to delete "${planTitle}"?`);
    if (!confirm) return;

    try {
      const numericPlanId = Number(planId);
      if (isNaN(numericPlanId)) {
        alert("Invalid plan ID.");
        return;
      }

      const response = await fetch(`/api/v1/subscription-plan/delete-plan/${numericPlanId}`, {
        method: 'DELETE',
      });

      if (!response.ok) {
        const data = await response.json();
        throw new Error(data.message || `Failed to delete plan (status ${response.status})`);
      }

      alert("Plan deleted successfully.");
      dispatch(deleteSubscription(numericPlanId));
    } catch (error) {
      console.error("Delete error:", error);
      alert(`Delete failed: ${error.message}`);
    }
  };

  return (
    <Tooltip title="Delete Subscription">
      <IconButton color="error" onClick={handleDelete}>
        <DeleteIcon />
      </IconButton>
    </Tooltip>
  );
};

export default DeleteSubscriptionButton;
